import { gql } from "@apollo/client";

export const GET_ADDRESS = gql`
  query GET_ADDRESS($addressId: ID!, $originatorId: ID!) {
    getAddress(addressId: $addressId, originatorId: $originatorId) {
      id
      city
      lat
      lng
      name
      state
      streetName
      streetNumber
      unit
      validAddressAlerts {
        createdAt
        officer {
          deptAttribute {
            id
            badge
            ori {
              id
              abbreviation
            }
          }
          personalAttribute {
            id
            firstName
            lastName
          }
        }
        id
        notes
      }
      zip
    }
  }
`;
